import { render, staticRenderFns } from "./AssetsDownload.vue?vue&type=template&id=c3fad30a"
import script from "./AssetsDownload.vue?vue&type=script&lang=js"
export * from "./AssetsDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports